const nextRoutesNurse = [
  "chief-complaint",
  "arrival-info",
  "actions",
  "vitals",
  "medical-hx",
  "assessments",
  "order-form",
  "iv-and-medications",
  "treatments",
  "radiology",
  "labs",
  "ekg",
  "procedures",
  "progress",
  "order-history",
  "supplies",
  "disposition",
];

const nextRoutesProvider = [
  "arrival-info",
  "vitals",
  "order-history",
  "hpi",
  "medical-hx",
  "ros",
  "physical-exam",
  "order-form",
  "iv-and-medications",
  "treatments",
  "radiology",
  "labs",
  "ekg",
  "procedures",
  "progress",
  "mdm",
  "clinical-impression",
  "er-summary",
  "disposition",
  "supplies",
  "procedural-sedation-note",
];

export { nextRoutesNurse, nextRoutesProvider };
